import { render, staticRenderFns } from "./text-package.mpx?vue&type=template&id=35cf74d8&scoped=true&component=true&componentId=text-package6f9d6f7c"
import script from "./text-package.mpx?vue&type=script&lang=js&component=true&componentId=text-package6f9d6f7c"
export * from "./text-package.mpx?vue&type=script&lang=js&component=true&componentId=text-package6f9d6f7c"
import style0 from "./text-package.mpx?vue&type=style&index=0&id=35cf74d8&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m6f9d6f7c%22%7D&component=true&componentId=text-package6f9d6f7c"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf74d8",
  null
  
)

export default component.exports